import { INITIALIZE_CONFIG } from './types';

export default function initializeConfig(config) {
  return {
    type: INITIALIZE_CONFIG,
    payload: {
      ...config,
    },
  };
}
